import { Navigate } from 'react-router-dom'

import { LoadingSpinner } from 'components/shared/LoadingSpinner'
import { useAuth } from 'contexts/AuthContext'
import { isAdminUserEmail } from 'utils/admin-user'

import type { ReactElement } from 'react'

interface AdminRouteProperties {
  children: ReactElement
}

export const AdminRoute = ({ children }: AdminRouteProperties): ReactElement => {
  /* --- Section 1: Hooks --- */
  const { user, loading } = useAuth()

  /* --- Section 5: Early Returns --- */
  if (loading) {
    return (
      <div className="App app-shell-loading-state">
        <LoadingSpinner />
      </div>
    )
  }

  if (!user || !isAdminUserEmail(user.email)) {
    return <Navigate to="/new" replace />
  }

  /* --- Section 6: Render --- */
  return children
}
